module.exports = __webpack_public_path__ + "img/family-benefits-pic1.87618c60.png";